import { VoidCallback } from '@deqo/foundation';
import { assertStr } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDefinition } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { KeyExpression } from '../../../platform/input/KeyExpression';

type KeyMappingToFunctionSource = [string, VoidCallback];
type KeyMappingToCommandSource = [string, CommandDefinition<unknown> | [CommandDefinition<unknown>, unknown[]]];

export type KeyMappingSource = KeyMappingToFunctionSource | KeyMappingToCommandSource;
export type KeyMappingInvoker = (d: CommandDispatcher) => void;
export type KeyMapping = readonly [KeyExpression, KeyMappingInvoker];
export type KeyMappings = readonly KeyMapping[];

const createInvoker = (input: KeyMappingSource[1]) => {
    if (Array.isArray(input) && typeof (input[1]) === 'object' && Array.isArray(input[1])) {
        return (d: CommandDispatcher) => d(input[0], input[1]);
    }
    if (typeof (input) === 'object') {
        return (d: CommandDispatcher) => d(input as any, []);
    }
    if (typeof (input) === 'function') {
        return input;
    }
    throw new Error(`KeyMapping: ${input} is not a valid key dispatcher?`);
};

export const KeyMappings = {
    empty: () => [] as KeyMapping[],
    from(...sources: readonly KeyMappingSource[]): KeyMapping[] {
        return sources.map(([es, cs]) => {
            assertStr(es, 'k');
            const expr = KeyExpression.parse(es);
            const invoker = createInvoker(cs);
            return [expr, invoker] as const;
        });
    },
};
